module.exports = __webpack_public_path__ + "static/img/skill-validating.ce958413.png";